'use client'
import React, {useContext} from "react"
import {
  Box,
  Button,
  useTheme,
  Typography,
  useMediaQuery, Stack,
} from "@mui/material"
import Image from "next/image"
import Grid from "@mui/material/Grid"
import CtaMobile from "@/ui/screens/home/CtaMobile"
import {GLOBAL_PATHS} from "@/lib/globals"
import {TranslationContext} from "@/configs/context"
import { GlassBox } from "@/ui/components/custom/box"


/**
 * Ce composant est un call to action de la page
 * @constructor
 */
const CtaWrapper: React.FC = () => {
  const theme = useTheme()
  // @ts-ignore
  const { t }: object = useContext(TranslationContext)
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))
  const matchlg = useMediaQuery(theme.breakpoints.up('lg'))
  const imageSize = 16*16

  return !matchMd ? <CtaMobile /> : (
    <Box
      id="cta-section"
      sx={{ pt: { xs: 2, md: 8 }, pb: { xs: 2, md: 8 } }}
    >
      <GlassBox
        sx={{
          px: 2, py: 2,
          color: "text.primary",
          textAlign: matchMd ? "left" : "center",
        }}
      >
        <Stack direction="column" alignItems="center" sx={{ mb: { xs: 4, md: 7 } }}>
          <Typography variant={matchMd ? "h4" : "h6"}>
            {t('translation:cta.title')}
          </Typography>
          <Typography variant={matchMd ? "body1" : "body2"} sx={{ marginTop: "0.5rem" }}>
            {t('translation:cta.content')}
          </Typography>
        </Stack>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent={matchlg ? "space-between" : "center"}
        >
          {[
            {
              label: "cta-vcard3",
              path: `${GLOBAL_PATHS.COVERS}vcard3.webp`,
            },
            {
              label: "cta-vcard2",
              path: `${GLOBAL_PATHS.COVERS}vcard2.webp`,
            },
            {
              label: "cta-vcard4",
              path: `${GLOBAL_PATHS.COVERS}vcard4.webp`,
            },
            {
              label: "cta-vcard5",
              path: `${GLOBAL_PATHS.COVERS}vcard5.webp`,
            },
          ].map((item) => (
            <Grid
              key={item.label}
              sx={{ textAlign: "center" }}
              size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 3 }}
            >
              <Image
                alt=""
                src={item.path}
                width={imageSize}
                height={imageSize*1.75}
                style={{ borderRadius: "16px" }}
              />
            </Grid>
          ))}
        </Grid>
        <Stack direction="column" alignItems="center" sx={{ mt: 3 }}>
          <Button
            size="large"
            variant="black-glass"
            href="#contact-section"
            sx={{ py: 2, px: 4 }}
          >
            {t('translation:cta.action')}
          </Button>
        </Stack>
      </GlassBox>
    </Box>
  )
}

export default CtaWrapper
